import { styled } from '@mui/material/styles';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';

export const CardContentStyled = styled(CardContent)({
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  overflowY: 'auto',
  padding: '24px  24px 16px !important',
});
